// Employee Activity — side drawer (2026-08-30, was an antd Modal). Opened from
// the "Activity" header button on both dashboards (Classic + Brain). Every
// add/edit/info surface in DashboardV2 is a slide-from-right drawer, so this
// one is too — same `Drawer` shell, same header anatomy. The export name is
// kept so no caller changes.
//
// The drawer body scrolls itself; the panel renders in its page layout
// (inModal=false) so the table paginates and the sticky drawer header stays put.
import React from 'react';
import { Users } from 'lucide-react';
import { Drawer } from '../../pages/DashboardV2/components/Drawer';
import EmployeeActivityPanel from './EmployeeActivityPanel';

export default function EmployeeActivityModal({ open, onClose }) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Employee Activity"
      subtitle="Live status and activity of your team"
      icon={<Users size={18} />}
      width={900}
    >
      {/* Only fetch while open; unmount on close so a reopen starts fresh. */}
      {open ? <EmployeeActivityPanel active={open} /> : null}
    </Drawer>
  );
}
